import {z} from 'zod';
import {MediaItemSchema} from "../../api/media-item-schema";
import {ApiResponseSchema} from "../../api/api-response-schema";

export const TechnologySchema = z.object({
  id: z.number(),
  name: z.string(),
  stack: z.string(),
  foto: MediaItemSchema.nullable().optional(),
});

export type Technology = z.infer<typeof TechnologySchema>;
//const TechnologyPreviewArraySchema = z.array(Technology);

export type TechnologyResponse = z.infer<typeof TechnologyResponseSchema>;


export const TechnologyResponseSchema = ApiResponseSchema(
  z.array(TechnologySchema),
);

export type TechnologySchemaKey = keyof typeof TechnologySchema.shape;

export const TechnologyParams = <const>{
  populate: <TechnologySchemaKey[]>['foto'],
  fields: <TechnologySchemaKey[]>[
    'id',
    'name',
    'stack',
  ],
};
